import { Event as GlobalEvent } from "../../../../Global/Base/Events";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { CrossFileEditElement } from "../../../UI.Controls/CrossFileEditElement";
import { FileEditProgressStatus } from "../FileMenu";
import { ControlParams } from "./ControlInterfaces";
import { FileEdit } from "./FileEdit";

export class CommentaryFrameAttachment extends FileEdit {
    //#region Events
    public readonly fileRemoved: GlobalEvent<CommentaryFrameAttachment, void> = new GlobalEvent<CommentaryFrameAttachment, void>();
    public readonly fileStartsUploading: GlobalEvent<CommentaryFrameAttachment, void> = new GlobalEvent<CommentaryFrameAttachment, void>();
    //#endregion Events

    //#region Fields
    protected override _fileEditElement: CrossFileEditElement;
    private readonly _cssClass = "commentary-frame-attachment";
    //#endregion Fields

    //#region Properties
    //#endregion Properties

    //#region Constructors
    constructor(params: ControlParams) {
        super(params);
        const { element } = params;

        this.finishDelay = 0;
        element.classList.add(this._cssClass);

        this._fileEditElement.removeButtonClicked.add(() => {
            this.fileRemoved.trigger(this);
        });
        this._fileEditElement.downloadFileClicked.add((_sender, _prm) => {
            this._downloadFile(false);
        });

        this.valueChanged.add(async (_sender, prm) => {
            if (this._attributeData != null && prm == this._attributeData) {
                const attrObject = AttrValueReader.read(await this.actualObject.getValue(this.attrName));
                if (attrObject == null) {
                    await this.actualObject.setValue(this.attrName, this._attributeData);
                }
            }
        });
    }
    //#endregion Constructors

    //#region Methods
    protected override _createFileElement(): void {
        const fileEdit = new CrossFileEditElement();
        this._appendFileElement(fileEdit);
    }

    public async processFile(file: File, actualObject: OWObject): Promise<boolean> {
        this.fileStartsUploading.trigger(this);
        this._fileEditElement.file = file;
        this.actualObject = actualObject;
        const isValid = await this._fileEditElement.callUploadRequest();
        if (!isValid)
            this._fileEditElement.file = null;
        return isValid;
    }

    public async reloadFile(): Promise<void> {
        this._fileEditElement.changeProgressStatus(FileEditProgressStatus.progressValue, 0);
        await this._fileEditElement.callUploadRequest();
    }

    public override dispose(): void {
        super.dispose();
    }
    //#endregion Methods
}
